module.exports = __webpack_public_path__ + "img/amb.59c23689.svg";